var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b2f0d721febf7731e8e448f0545f9c5109259dc2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yapdomik-frontend-website@sushi-market"]={id:"b2f0d721febf7731e8e448f0545f9c5109259dc2"};
      